// @ts-nocheck
import { defineComponent, computed } from 'vue';
import type { PropType } from 'vue';
import type { SVGJson, TreeObj } from '../utils/use-render';
import { renderFn, formatColor } from '../utils/use-render';
import { useNamespace } from '@nio-fe/shared';
import '../style/index.scss';

const element: SVGJson = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"path","attrs":{"fill":"#26BD4B","d":"M4.96 2a.9.9 0 00-.67.3C4.1 2.5 4 2.75 4 3v18c0 .25.1.52.29.7.19.2.43.3.67.3h14.08c.24 0 .5-.1.67-.3A1 1 0 0020 21V7.5L14.5 2H4.96z"}},{"tag":"path","attrs":{"fill":"#fff","d":"M14 16l-1.9-3.04L10.21 16h-.9l2.33-3.6L9.5 9h.85l1.74 2.83L13.86 9h.85l-2.16 3.39L14.89 16H14z"}},{"tag":"path","attrs":{"fill":"#EDFCEF","d":"M20 7.5h-4.47a1 1 0 01-.72-.3.98.98 0 01-.31-.73V2L20 7.5z","opacity":0.5}}]};

export default defineComponent({
  name: 'IconExcelFilledLight',
  props: {
    color: {
      type: [Array, String] as PropType<string[] | string>,
      required: false,
      default: () => [],
    },
    spin: {
      type: String as PropType<'cw' | 'ccw'>,
      required: false,
    },
    size: {
      type: [String, Number],
      required: false,
      // default: 24,
    },
    rotate: {
      type: Number,
      required: false,
    },
  },
  emits: {
    click: (evt: MouseEvent) => evt instanceof MouseEvent,
  },
  setup(props, { attrs, emit }) {
    return () => {
      const { size, color, spin, rotate } = props;
      const prefix = `${useNamespace()}-icon`.toLowerCase();

      const spinClassName = `${spin ? `${prefix}_spin-${spin}` : ''}`;
      const iconStyle = computed(() => ({
        fontSize: size,
        transform: `rotate(${rotate}deg)`,
        ...(attrs.style as StyleSheet),
      }));
      const finalColor = computed(() => formatColor(color));
      const finalClass = computed(() => [prefix, `${prefix}__excel_filled_light`, spinClassName, attrs.class]);
      const finalProps = {
        class: finalClass.value,
        style: iconStyle.value,
        onClick: (evt: MouseEvent) => emit('click', evt),
      };

      return renderFn(element, finalProps, finalColor.value as TreeObj);
    };
  },
});
